import { Component, EventEmitter, Output } from '@angular/core';
import {
  warningTriangleIcon, SVGIcon
} from '@progress/kendo-svg-icons';

@Component({
  selector: 'app-iep-close-confirmation',
  templateUrl: './iep-close-confirmation.component.html',
  styleUrls: ['./iep-close-confirmation.component.scss'],
  standalone: false,
})
export class IepCloseConfirmationComponent {
  @Output() closeEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirmEmitter: EventEmitter<void> = new EventEmitter<void>();
  public warningTriangleIcon: SVGIcon = warningTriangleIcon;
  closeDialog(): void{
    this.closeEmitter.next();
  }

  onConfirm(): void{
    this.confirmEmitter.next();
  }

  onClickBack(): void{
    this.closeDialog();
  }

}
